import dynamic from 'next/dynamic';

const InfoCircleSVG = dynamic(() => import('components/iconsSVG/infoCircle').then((mod) => mod.InfoCircleSVG));

export function StoreStatus({ status, statusText }: { status: string; statusText: string }) {
  const className = {
    abierta: 'text-[var(--color-success)] text-[9px]',
    cerrado: 'text-[var(--color-error)]',
    'cierre temporal': 'text-[var(--color-warning)]',
  };
  return (
    <p className={`mb-0 mt-[5px] flex items-center gap-[5px] uppercase ${className[status as keyof typeof className] ?? className.abierta}`}>
      <InfoCircleSVG className="-mt-px" />
      {statusText}
    </p>
  );
}
